var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCeCreamIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce_Cream_icon_svg__clip0_2002_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 684.786c82.843 0 150-67.158 150-150 0-82.843-67.157-150-150-150s-150 67.157-150 150c0 82.842 67.157 150 150 150z",
    fill: "#806B4B",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.44 499.286h49.108c56.642 0 106.762-37.929 120.785-92.81 3.024-11.821 4.631-24.202 4.655-36.964.143-80.322-63.893-147.119-144.155-150.167-85.5-3.25-155.845 65.107-155.845 149.893 0 12.798 1.607 25.214 4.619 37.071 13.976 54.953 64.131 92.977 120.833 92.977z",
    fill: "#fff",
    stroke: "#FED425",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 206.738c-86.845 0-158 68.488-162.298 154.298v58.202c0 11.048 8.953 20 20 20 11.048 0 20-8.952 20-20v-40.405c0-9.833 7.965-17.797 17.798-17.797 9.833 0 17.798 7.964 17.798 17.797v12.084c0 11.047 8.952 20 20 20 11.047 0 20-8.953 20-20v-5.643c0-13.381 10.857-24.238 24.238-24.238s24.238 10.857 24.238 24.238v33.964c0 11.048 8.952 20 20 20 11.047 0 20-8.952 20-20v-17.952c0-22.238 18.024-40.262 40.262-40.262s40.262 18.024 40.262 40.262v17.952c0 11.048 8.952 20 20 20 11.047 0 20-8.952 20-20v-58.202c-4.286-85.81-75.441-154.298-162.298-154.298z",
    fill: "#806B4B",
    stroke: "#415849",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.524 163.012c6.643-26.893 29.595-45.464 55.726-47.798",
    stroke: "#E2142D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 250.81c29.278 0 53.012-23.735 53.012-53.012 0-29.278-23.734-53.012-53.012-53.012s-53.012 23.734-53.012 53.012c0 29.277 23.734 53.012 53.012 53.012z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.107 658.667l14.369 180.095c2.072 25.988 23.774 46.024 49.845 46.024h109.358c26.071 0 47.761-20.036 49.845-46.024l14.369-180.095H381.107z",
    fill: "#F9B485",
    stroke: "#F99652",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 794.988l110.202-110.202M464.798 834.786L575 724.583M425 724.583l110.202 110.203M464.798 684.786L575 794.988",
    stroke: "#F99652",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.81 646.833H433.19c-35.059 0-64.535-25.083-71.392-58.19h-1.5v48.524c0 40.083 32.797 72.893 72.892 72.893h133.62c40.083 0 72.892-32.798 72.892-72.893v-48.524h-1.5c-6.845 33.107-36.333 58.19-71.392 58.19z",
    fill: "#F9B485",
    stroke: "#F99652",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.631 633.762v24.94c0 11.191-9.071 20.274-20.274 20.274-11.19 0-20.274-9.071-20.274-20.274v-24.94",
    fill: "#806B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.631 633.762v24.94c0 11.191-9.071 20.274-20.274 20.274-11.19 0-20.274-9.071-20.274-20.274v-24.94",
    stroke: "#BE7F4D",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 479.571v24.941c0 11.19-9.071 20.274-20.274 20.274-11.19 0-20.274-9.072-20.274-20.274v-24.941",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 479.571v24.941c0 11.19-9.071 20.274-20.274 20.274-11.19 0-20.274-9.072-20.274-20.274v-24.941",
    stroke: "#FED425",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.976 189.333c3.667 0 7.262.096 10.786.286 8.571.452 13.381-10.048 7.143-15.952a25.95 25.95 0 00-17.929-7.143c-6.952 0-12.869 2.547-17.5 6.738-6.571 5.952-2.119 16.809 6.738 16.345 3.512-.19 7.107-.286 10.762-.286v.012z",
    fill: "#FA99A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.774 283.345l17.547 17.548",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.774 298.345l-17.548 17.548",
    stroke: "#FA99A1",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.679 283.345l17.547 17.548",
    stroke: "#FED425",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ce_Cream_icon_svg__clip0_2002_375"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeCreamIcon);
export default ForwardRef;